import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  sectionTitle: {
    id: 'mK4GCu',
    defaultMessage: 'Account Information',
    description: 'Section title for the read-only account information summary',
  },
  contactFullNameRequired: {
    id: 'v944Nd',
    defaultMessage: 'Name is required',
    description: 'Shown in the account information summary when the contact name is missing',
  },
  companyNameRequired: {
    id: 'vV07Ve',
    defaultMessage: 'Company is required',
    description: 'Shown in the account information summary when the company name is missing',
  },
  emailRequired: {
    id: '6cC0l7',
    defaultMessage: 'Email is required',
    description: 'Shown in the account information summary when the email is missing',
  },
  phoneNumberRequired: {
    id: '41yz/6',
    defaultMessage: 'Phone number is required',
    description: 'Shown in the account information summary when the phone number is missing',
  },
});
